import styled from '@emotion/styled';

const CallOut = styled('div')(({ theme }) => ({
  color: theme.colors.white.primary,
  float: 'left',
  padding: '.7rem 0 0 .8rem',
}));

export default CallOut;
